module.exports = __webpack_public_path__ + "static/media/30_CALCINHA_FIO_DUPLO_ESTAMPADA_02.d45d3f45.jpg";